import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, LabelList } from 'recharts'
import BSDCard from '../BSDCard'
import { CHART_TOOLTIP_STYLE, type CompareAmbitiPoint } from '../../utils/dashboardFormatters'
import type { SezioneCard } from '../SectionBadge'

export default function CompareAmbitiBarCard({
  title,
  data,
  formatter,
  valueLabel,
  sezione = 'Dati demografici',
}: {
  title: string
  data: CompareAmbitiPoint[]
  formatter: (value: number) => string
  valueLabel: string
  sezione?: SezioneCard
}) {
  const orderedData = [...data].sort((a, b) => a.name.localeCompare(b.name, 'it'))
  const isMobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches
  const chartHeight = isMobile ? 172 : 170

  return (
    <BSDCard kind="panel" sezione={sezione} zoomable>
      <h3 className="telemetry-section-title" style={{ marginTop: 0, marginBottom: 8 }}>{title}</h3>
      <div className="compare-chart-scroll">
        <div className="compare-chart-scroll-inner compare-chart-scroll-inner--bar">
          <ResponsiveContainer width="100%" height={chartHeight}>
            <BarChart data={orderedData} layout="vertical" margin={{ top: 2, right: isMobile ? 0 : 60, bottom: 2, left: 6 }}>
              <XAxis type="number" hide />
              <YAxis type="category" dataKey="name" tick={{ fontSize: isMobile ? 9 : 10, fill: 'var(--text-2)' }} axisLine={false} tickLine={false} width={isMobile ? 86 : 70} />
              <Tooltip
                {...CHART_TOOLTIP_STYLE}
                cursor={{ fill: 'rgba(255,255,255,0.04)' }}
                formatter={(value: number | string | undefined) => [formatter(Number(value ?? 0)), valueLabel]}
              />
              <Bar dataKey="value" radius={[0, 6, 6, 0]} barSize={14}>
                {!isMobile && (
                  <LabelList
                    dataKey="value"
                    position="right"
                    formatter={(value) => formatter(Number(value ?? 0))}
                    fill="var(--text-2)"
                    fontSize={10}
                  />
                )}
                {orderedData.map((entry) => (
                  <Cell key={`compare-${title}-${entry.id}`} fill={entry.color} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </BSDCard>
  )
}
